import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type PaymentWay = components['schemas']['PaymentWay'];

type FetchPaymentWaysOperation = paths['/executor_web/payment_ways']['get'];

export type FetchPaymentWaysResponse = FetchPaymentWaysOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/payment_ways` — см. `paths['/executor_web/payment_ways']` в auth swagger */
export function fetchPaymentWays(signal?: AbortSignal) {
	return axiosInstance.get<FetchPaymentWaysResponse>('payment_ways', {signal});
}
